import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/auth';

export function PrivateRoute({ children, adminOnly = false }: { children: React.ReactNode; adminOnly?: boolean }) {
  const { isAuthenticated, isAdmin } = useAuthStore();
  const loc = useLocation();
  if (!isAuthenticated()) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (adminOnly && !isAdmin()) return <Navigate to="/" replace />;
  return <>{children}</>;
}
